import { Controller } from '@hotwired/stimulus';

export default class UboCardController extends Controller {
  static targets = ['controlSelect', 'otherControl'];

  toggleOther() {
    if (!this.hasControlSelectTarget || !this.hasOtherControlTarget) return;

    const isOther = this.controlSelectTarget.value === 'other';

    this.otherControlTarget.disabled = !isOther;
    this.otherControlTarget.required = isOther;
  }

  remove() {
    this.element.remove();
  }
}
